import config from '../config'

export const API_URL_LIVE = config.API_URL
export const API_REGISTER_ROUTE = `${API_URL_LIVE}/register`
export const API_LOGIN_ROUTE = `${API_URL_LIVE}/oauth2/token`
export const API_LOGOUT_ROUTE = `${API_URL_LIVE}/oauth2/logout`
export const API_REFRESH_TOKEN_URL = `${API_URL_LIVE}/oauth2/token`
